/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner } from './get-purchase-application-templates-detail200-response-template-overview-approvers-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy } from './get-purchase-application-templates-detail200-response-template-overview-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy } from './get-purchase-application-templates-detail200-response-template-overview-submitted-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount } from './get-purchase-application-templates-detail200-response-template-overview-user-account';

/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
 */
export interface GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'purchaseTemplateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'templateId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'templateName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'scopeDisclosure': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewScopeDisclosureEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'templateCategory': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'templateDetail': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'submittedBy': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'submittedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'purposeOfUse': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'amount': number | null;
    /**
     * 
     * @type {GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'userAccount': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewUserAccount | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'isOnDemandCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'remarks': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'createdBy': GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewCreatedBy;
    /**
     * 
     * @type {Array<GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner>}
     * @memberof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverview
     */
    'approvers': Array<GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewApproversInner>;
}

export const GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewScopeDisclosureEnum = {
    public: 'PUBLIC',
    individual: 'INDIVIDUAL'
} as const;

export type GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewScopeDisclosureEnum = typeof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewScopeDisclosureEnum[keyof typeof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewScopeDisclosureEnum];
export const GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewPurposeOfUseEnum = typeof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewPurposeOfUseEnum[keyof typeof GetPurchaseApplicationTemplatesDetail200ResponseTemplateOverviewPurposeOfUseEnum];


